export default __webpack_public_path__ + "static/bg-section-11-03238a889fa9d198b2df12aec21c0eb9.svg";